/**
 * Firebase/GCS object names should avoid characters that break URLs or paths.
 * Windows screenshots often include ":" in the time portion.
 */
export function sanitizeStorageFileName(name) {
  if (!name || typeof name !== 'string') return 'file';
  const base = name.replace(/\s+/g, '_');
  const safe = base.replace(/[^a-zA-Z0-9._-]/g, '_').replace(/_+/g, '_');
  return safe.length > 0 ? safe : 'file';
}
